"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _MediaCreativeLayer2 = _interopRequireDefault(require("./MediaCreativeLayer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SVGCreativeLayer = /*#__PURE__*/function (_MediaCreativeLayer) {
  (0, _inherits2["default"])(SVGCreativeLayer, _MediaCreativeLayer);

  var _super = _createSuper(SVGCreativeLayer);

  function SVGCreativeLayer() {
    (0, _classCallCheck2["default"])(this, SVGCreativeLayer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SVGCreativeLayer, null, [{
    key: "isSVGCreativeLayer",

    /**
     * Checks if object is an instance of SVGCreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */
    value: function isSVGCreativeLayer(inputObject) {
      return inputObject instanceof SVGCreativeLayer;
    }
  }]);
  return SVGCreativeLayer;
}(_MediaCreativeLayer2["default"]);

exports["default"] = SVGCreativeLayer;